export default "__VITE_ASSET__2321ac38__"